import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { userRepo } from "@/repo/user-repo";
import Header from "@/component/header";
import Footer from "@/component/footer";
import ListMoviesGrid from "./_components/list-movies-grid";
import { PublicListData } from "@/entry/server/user";
import { Movie } from "@/entry/server/movie";
import { Pagination } from "@/lib/api";
import { useQueryParams, getQueryParam } from "@/hooks/useQueryParams";
import NotFound from "@/pages-app/not-found";

export default function Page() {
    const routeParams = useParams<{ id: string }>();
    const queryParams = useQueryParams();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);
    const [list, setList] = useState<PublicListData | null>(null);
    const [movies, setMovies] = useState<Movie[]>([]);
    const [pagination, setPagination] = useState<Pagination | null>(null);

    useEffect(function () {
        var id = routeParams.id;
        if (!id || isNaN(Number(id))) {
            setNotFound(true);
            setLoading(false);
            return;
        }

        setLoading(true);
        setNotFound(false);
        var page = getQueryParam(queryParams, "page", "1");

        userRepo.getPublicList(Number(id)).then(function (listResponse) {
            if (!listResponse.status) {
                console.error(listResponse.message);
                setNotFound(true);
                setLoading(false);
                return;
            }

            if (listResponse.data) {
                setList(listResponse.data);
            }

            userRepo.getListMovies(Number(id), Number(page), 12).then(function (moviesResponse) {
                if (!moviesResponse.status) {
                    console.error(moviesResponse.message);
                    setNotFound(true);
                    setLoading(false);
                    return;
                }

                if (moviesResponse.data) {
                    setMovies(moviesResponse.data);
                } else {
                    setMovies([]);
                }
                if (moviesResponse.pagination) {
                    setPagination(moviesResponse.pagination);
                }
                setLoading(false);
            });
        });
    }, [routeParams.id, location.search]);

    if (notFound) {
        return <NotFound />;
    }

    if (loading || !list || !pagination) {
        return (
            <div className="page-loading">
                <div className="loader" />
            </div>
        );
    }

    return (
        <>
            <Header />
            <ListMoviesGrid defaultMovies={movies} defaultPagination={pagination} id={Number(routeParams.id)} list={list} />
            <Footer />
        </>
    );
}
